<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="stockplace_name_from" [(ttModel)]="setting.stockplace_name_from" ttReadonly></tt-input>
        <tt-input ttRememberId="w_stockplacesto.searchtext" ttLabel="searchtext" [ttFocus]="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListStockPlacesTo" [ttFilter]="setting.searchtext"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="stockplace_name_from" tt-model="vm.model.setting.stockplace_name_from" tt-change="vm.model.setting.stockplace_name_from = $value" tt-readonly="true"></tt-input>
        <tt-input-buttons class="col-xs-12 sp-0" tt-label="searchtext" tt-focus="false" tt-model="vm.model.setting.searchtext" tt-on-blur="vm.onBlur('searchtext')" tt-change="vm.onChanged($value, 'searchtext')" tt-placeholder="" tt-buttons="vm.model.searchTextButtons"></tt-input-buttons>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListStockPlacesTo" badge="" ltype="" design-var="s12t0" filter-val="vm.model.setting.searchtext"></im-list-directive>
</tt-page>-->
